export const ORGANIZATION_TIMECARDS_LIST_QUERY_KEY = 'organization-timecards-list';
export const TIMECARD_QUERY_KEY = 'timecard';
export const TIMECARD_NOTES_QUERY_KEY = 'timecard-notes';
export const TIMECARD_STATUS_HISTORY_QUERY_KEY = 'timecard-status-history';
export const TIMECARD_CHANGE_HISTORY_QUERY_KEY = 'timecard-change-history';
export const TIMECARD_EXPENSES_QUERY_KEY = 'timecard-expenses';
export const TIMECARD_EXPENSE_CHANGE_HISTORY_QUERY_KEY = 'timecard-expense-change-history';
export const TIMECARD_SHIFT_CHANGE_HISTORY_QUERY_KEY = 'timecard-shift-change-history';
export const TIMECARD_DOCUMENTS_COUNT_QUERY_KEY = 'timecard-documents-count';
export const EXPENSE_CATEGORIES_QUERY_KEY = 'expense-categories';
